export default __webpack_public_path__ + "df59392137c5d5b65fc24184f93eb328.png";